var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.07332 1.63357C7.84012 1.15659 7.16032 1.15659 6.92713 1.63358L1.95391 11.8061C1.74672 12.2299 2.05527 12.7242 2.52701 12.7242H12.4734C12.9452 12.7242 13.2537 12.2299 13.0465 11.8061L8.07332 1.63357ZM5.78093 1.07322C6.48051 -0.357735 8.51993 -0.357741 9.21951 1.07321L14.1927 11.2457C14.8143 12.5171 13.8886 14 12.4734 14H2.52701C1.11181 14 0.186147 12.5171 0.807716 11.2457L5.78093 1.07322Z",
    fill: "#FFB000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.8623 4.75018C6.8623 4.39787 7.14791 4.11226 7.50022 4.11226C7.85253 4.11226 8.13814 4.39787 8.13814 4.75018V8.25873C8.13814 8.61104 7.85253 8.89665 7.50022 8.89665C7.14791 8.89665 6.8623 8.61104 6.8623 8.25873V4.75018Z",
    fill: "#FFB000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.45711 10.8104C8.45711 11.3389 8.0287 11.7673 7.50023 11.7673C6.97177 11.7673 6.54336 11.3389 6.54336 10.8104C6.54336 10.2819 6.97177 9.85353 7.50023 9.85353C8.0287 9.85353 8.45711 10.2819 8.45711 10.8104Z",
    fill: "#FFB000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.b2ecdb8b5b753ca8e2a35811e99faca4.svg";
export { ForwardRef as ReactComponent };